import React, { useState, useEffect } from "react";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import { modules } from "../../../constants/Modules";
import { useGetNotOnboardedUsers } from "../../../queryHooks";
import { useStore } from "../../../zustand/store";
import CS from "../../../services/commonService";
import qs from "qs";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";

const GuestUsers = () => {
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	//	State values
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.GUEST_USERS]?.page || 1
	);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.GUEST_USERS]?.items_per_page || 10
	);
	const [usersPayload, setUsersPayload] = useState(
		lastPageData?.[modules.GUEST_USERS] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { name: "DESC" },
			filter: {
				is_guest_user: true,
			},
		}
	);

	/******************************************************************************************
	@Purpose    :   To get the users list
	*******************************************************************************************/

	const {
		data: dataGetAllUsers,
		isLoading,
		refetch,
	} = useGetNotOnboardedUsers(qs.stringify(usersPayload));

	useEffect(() => {
		if (dataGetAllUsers && dataGetAllUsers.status === "success") {
			let respData = dataGetAllUsers.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetAllUsers]);

	const columns = [
		{
			label: "User Id",
			type: "string",
			// sort: true,
			path: "id",
			// alias: "mobile",
		},
		{
			label: "Joined Date",
			type: "date",
			sort: true,
			filterDate: true,
			path: "created_at",
			alias: "created_at",
			content: (item) => getCurrentTimezoneDate(item.created_at),
		},
		{
			label: "Phone Number",
			type: "string",
			// sort: true,
			path: "mobile",
			// alias: "mobile",
		},
	];

	return (
		<React.Fragment>
			<div className="grid-content">
				<div className="user-listing-filterOptions mb-2 d-block">
					<div className="row mb-2">
						<div className="col-sm-8 mb-2 position-static">
							<div className="left-buttons d-flex">
								<SearchBox
									columnKey={modules.GUEST_USERS}
									searchValue={
										lastPageData?.[modules.GUEST_USERS]?.search?.mobile
									}
									search={(value) => {
										setPageNow(1);
										setUsersPayload({
											...usersPayload,
											search: {
												mobile: !value && value === "" ? undefined : value,
											},
											page: 1,
										});
									}}
								/>
							</div>
						</div>
					</div>
				</div>
				<Table
					columnKey={modules.GUEST_USERS}
					columns={columns}
					tableData={tableData}
					payload={usersPayload}
					sortCol={(obj) => {
						setPageNow(1);
						setUsersPayload({
							...usersPayload,
							sort: {
								[obj.alias]:
									!obj.sort && obj.sort === "" ? undefined : obj.sort,
							},
							page: 1,
						});
					}}
					setCurrentPage={(page) => {
						setPageNow(page);
						setUsersPayload({
							...usersPayload,
							page,
						});
					}}
					setCurrentLimit={(items_per_page) => {
						setPageNow(1);
						setItemsPerPage(items_per_page);
						setUsersPayload({
							...usersPayload,
							items_per_page,
							page: 1,
						});
					}}
					loading={isLoading}
					filterValue={async (obj) => {
						if (obj.filter === null) {
							const resp = await CS.filterData(usersPayload.filter, obj);
							setPageNow(1);
							setUsersPayload({
								...usersPayload,
								filter: resp,
								page: 1,
							});
						} else {
							setPageNow(1);
							setUsersPayload({
								...usersPayload,
								filter: {
									...usersPayload.filter,
									[obj.alias]: obj.filter,
								},
								page: 1,
							});
						}
					}}
					filterDate={(dates) => {
						setPageNow(1);
						setUsersPayload({
							...usersPayload,
							filter_date: dates && {
								[dates.alias]: String(dates.filter),
							},
							page: 1,
						});
					}}
				/>
			</div>
		</React.Fragment>
	);
};

export default GuestUsers;
